import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {VIEW_STATE} from "../utils/enums";

const slice = createSlice({
    name: 'province',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        viewState2: null,
        provinces: [],
        cities: []
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setViewState2: (state, action) => {
            state.viewState2 = action.payload
        },
        setProvinces: (state, action) => {
            state.provinces = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
        setCities: (state, action) => {
            state.cities = action.payload
            state.viewState2 = VIEW_STATE.LOADED
        },
    },
});

export default slice.reducer
const {setViewState, setViewState2, setProvinces, setCities} = slice.actions

export const getProvinces = () => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.province.get()
        dispatch(setProvinces(data.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
export const getCities = (provinceId) => async dispatch => {
    try {
        dispatch(setViewState2(VIEW_STATE.LOADING))
        const {data} = await api.province.getCities(provinceId)
        dispatch(setCities(data.data));
    } catch (e) {
        dispatch(setViewState2(VIEW_STATE.ERROR))
    }
}
